/* eslint-disable @typescript-eslint/no-magic-numbers */
import posthog from 'posthog-js';

import Constants from './Constants';

export default function initPostHog(appVersion = 'unknown') {
  const enablePostHog = import.meta.env.VITE_ENABLE_POSTHOG === 'true' || false;

  if (!enablePostHog) {
    // eslint-disable-next-line no-console
    console.info('PostHog is not enabled');
    return;
  }

  const deviceId = localStorage.getItem('device-id') ?? '';

  posthog.init(import.meta.env.VITE_POSTHOG_KEY as string, {
    api_host: import.meta.env.VITE_POSTHOG_HOST as string,
    autocapture: true,
    capture_pageview: true,
  });

  const fullVersion = `${appVersion} (${Constants.APP_VERSION})`;

  posthog.identify(deviceId, {
    app_version: appVersion,
    environment: import.meta.env.VITE_ENVIRONMENT as string,
  });

  posthog.register({
    app_version: fullVersion,
    environment: import.meta.env.VITE_ENVIRONMENT as string,
    device_id: deviceId,
  });
}
